/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import {
  BaseAlertCardAdAlertFragmentDoc,
  BaseAlertCardVehicleFragmentDoc,
} from '../../../../alert-cards-common/src/lib/BaseAlertCard/BaseAlertCard.hook'
import { VehicleIconLinkVehicleFragmentDoc } from '../../../../alert-cards-common/src/lib/VehicleIconLink/vehicleIconLink.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type OperatorCallAdAlertCardAlertFragment = {
  __typename: 'FccAdAlert'
  id: string
  status: Types.FccAdAlertStatus
  type: Types.FccAdAlertType
  vehicle: {
    __typename?: 'Vehicle'
    totalPassengersInVehicle: number | null
    id: string
    inService: boolean | null
    label: number | null
    isSelfDriving: boolean
  } | null
  assignee: {
    __typename?: 'BackofficeUser'
    id: string
    username: string
  } | null
  statusChanges: Array<{
    __typename: 'FccAdAlertStatusChange'
    bySystem: boolean
    date: string
    to: Types.FccAdAlertStatus
    byUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const OperatorCallAdAlertCardAlertFragmentDoc = gql`
    fragment OperatorCallAdAlertCardAlert on FccAdAlert {
  ...BaseAlertCardAdAlert
  vehicle {
    totalPassengersInVehicle
    ...VehicleIconLinkVehicle
    ...BaseAlertCardVehicle
  }
}
    ${BaseAlertCardAdAlertFragmentDoc}
${VehicleIconLinkVehicleFragmentDoc}
${BaseAlertCardVehicleFragmentDoc}`
